import { useState, useEffect, useMemo } from 'react';
import { ScreenSizeCategoryEnum } from '../_common/enum/screenSizeCategory.enum';
import { WindowSizeBreakpoints } from '../_const/windowSize.const';

export const useScreenSize = () => {
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return screenSize;
};

export function getWindowSizeCategory(width: number) {
    if (width < WindowSizeBreakpoints.small) {
        return ScreenSizeCategoryEnum.XS;
    } else if (width >= WindowSizeBreakpoints.small && width < WindowSizeBreakpoints.medium) {
        return ScreenSizeCategoryEnum.SM;
    } else if (width >= WindowSizeBreakpoints.medium && width < WindowSizeBreakpoints.large) {
        return ScreenSizeCategoryEnum.MD;
    } else if (width >= WindowSizeBreakpoints.large && width < WindowSizeBreakpoints.extraLarge) {
        return ScreenSizeCategoryEnum.LG;
    } else {
        return ScreenSizeCategoryEnum.XL;
    }
}

export function useIsMobileView (
    screenSizeCategory?: ScreenSizeCategoryEnum | null
): boolean {
    const isMobile = useMemo(() => {
        if (!screenSizeCategory) return false; 
        return (
            screenSizeCategory === ScreenSizeCategoryEnum.XS ||
            screenSizeCategory === ScreenSizeCategoryEnum.SM
        );
    }, [screenSizeCategory]);

    return isMobile;
};